import { useEffect, useRef, useState } from 'react';
import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch';

import { Chip, ScrollArrows } from 'components/@tedui';

import { useModalStore } from '../../../Modals';
import { transformItems } from './utils';

export function CurrentRefinements(): React.ReactNode {
  const { status } = useInstantSearch();
  const { items, refine } = useCurrentRefinements({
    transformItems,
    includedAttributes: ['duration', 'tags', 'subtitle_languages']
  });

  const removeSelectedTopic = useModalStore(state => state.removeSelectedTopic);
  const isLoading = status === 'stalled' || status === 'loading';

  const [showArrows, setShowArrows] = useState(false);
  const scrollAreaRef = useRef<HTMLDivElement>(null);

  const clearRefinement = value => {
    refine(value);
    removeSelectedTopic(value.value);
  };

  const checkOverflow = () => {
    if (!isLoading && scrollAreaRef.current) {
      setShowArrows(
        scrollAreaRef.current.offsetWidth < scrollAreaRef.current.scrollWidth
      );
    }
  };

  useEffect(() => {
    if (!scrollAreaRef.current) return;

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [isLoading, items]);

  return (
    <div
      className="flex gap-2 overflow-auto scroll-smooth pt-2 scrollbar-hide"
      ref={scrollAreaRef}
    >
      <ScrollArrows
        scrollAreaRef={scrollAreaRef}
        showArrows={showArrows}
        adjustArrowButtonPosition
      />

      {items.map(item =>
        item.refinements.map(refinement => (
          <Chip
            key={refinement.label}
            text={refinement.label}
            id={refinement.label.toLowerCase()}
            onChange={() => clearRefinement(refinement)}
            applied
          />
        ))
      )}
    </div>
  );
}
